import { render, staticRenderFns } from "./GearModal.vue?vue&type=template&id=bbf209d0&scoped=true"
import script from "./GearModal.vue?vue&type=script&lang=js"
export * from "./GearModal.vue?vue&type=script&lang=js"
import style0 from "./GearModal.vue?vue&type=style&index=0&id=bbf209d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf209d0",
  null
  
)

export default component.exports